import React, { Component } from "react";
import { connect } from "react-redux";
import RaisedButton from "material-ui/RaisedButton";
import ActionPrint from "material-ui/svg-icons/action/print";
import { showNotification as showNotificationAction } from "admin-on-rest";
import { push as pushAction } from "react-router-redux";
import { fullWhite } from "material-ui/styles/colors";
import axios from "axios";
var Config = require("../config");

class PrintButton extends Component {
  handleClick = () => {
    window.print();

    const { record } = this.props;
    var id = record.id;
    var auth_token = localStorage.getItem("auth_token");

    axios
      .post(Config.serverUrl + `api/update_order`, {
        rec: id,
        token: auth_token
      })
      .then(res => {
        console.log(res);
        console.log(res.data);
      });
  };

  render() {
    return (
      <RaisedButton
        label="Print"
        onClick={this.handleClick}
        primary={true}
        icon={<ActionPrint color={fullWhite} />}
      />
    );
  }
}

export default connect(
  null,
  {
    showNotification: showNotificationAction,
    push: pushAction
  }
)(PrintButton);



// WEBPACK FOOTER //
// ./src/custom/PrintButton.js